import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=1a49bc2c&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=js&"
export * from "./InfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=1a49bc2c&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49bc2c",
  null
  
)

export default component.exports